import { render, staticRenderFns } from "./student-reg-table.vue?vue&type=template&id=061e2af0"
import script from "./student-reg-table.vue?vue&type=script&lang=js"
export * from "./student-reg-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports